import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import { FaPhone, FaSearch } from "react-icons/fa";
import { Modal, Button, Toast, ToastContainer } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import { useParams } from "react-router-dom";
const PaymentPage = () => {
  const { _id } = useParams(); // customerId from URL

  // ⚡ For now, dummy data. Later, fetch real data by id.
  const customer = {
    customerId: _id,
    name: "John Doe",
    insuranceType: "Health",
    premium: 5000,
    dueDate: "15th Sept 2025",
  };

  return (
    <div className="container d-flex flex-column align-items-center justify-content-center vh-100">
      <div
        className="card shadow p-4 rounded-4 text-center"
        style={{ maxWidth: "500px", width: "100%" }}
      >
        <h3 className="fw-bold mb-3">Payment Page</h3>

        {/* Customer details */}
        <p className="text-muted mb-1">
          Customer ID: <span className="fw-semibold">{customer.customerId}</span>
        </p>
        <p className="mb-4">
          Hi <strong>{customer.name}</strong>, your{" "}
          <strong>{customer.insuranceType}</strong> insurance premium is due.
        </p>

        {/* Premium amount */}
        <div className="my-4">
          <h5>Amount Due</h5>
          <p className="fs-4 fw-bold text-success">
            ₹{Number(customer.premium).toLocaleString()}
          </p>
          <p className="text-muted">Due Date: {customer.dueDate}</p>
        </div>

        {/* Pay button */}
        <button className="btn btn-primary w-100 py-2 mb-3">
          Proceed to Pay
        </button>

        {/* Coming Soon note */}
        <p className="mt-3 text-warning fw-semibold">⚡ Payment Gateway Coming Soon</p>
      </div>
    </div>
  );
};

export default PaymentPage;
